import { useState, useEffect } from 'react';
import { Button } from 'react-bootstrap';

const CookieComponent = () => {

  const [cookie, setCookie] = useState()

  const setCookieInfoHide = () => {
    localStorage.setItem("hideCookie", true);
    setCookie(false)
  }

  useEffect(() => {
    if(localStorage.getItem("hideCookie") === undefined || localStorage.getItem("hideCookie") === null || localStorage.getItem("hideCookie") === false && cookie !== true){
      setCookie(true);
    }
  })
  
  let cookieInfo = "";
  if(cookie){
    cookieInfo = <div className="cookieWrapper">
    <p>
      <strong>Ważne: Strona wykorzystuje pliki cookie</strong>
    </p>
    <p>
    W ramach naszej witryny stosujemy pliki cookies w celu świadczenia Państwu usług na najwyższym poziomie, w tym w sposób dostosowany do indywidualnych potrzeb. Korzystanie z witryny bez zmiany ustawień dotyczących cookies oznacza, że będą one zamieszczane w Państwa urządzeniu końcowym. Możecie Państwo dokonać w każdym czasie zmiany ustawień dotyczących cookies. Więcej szczegółów w naszej "Polityce Cookies".
    </p>
    <Button variant="info" onClick={() => setCookieInfoHide()}>Zamknij</Button>
  </div>
  }

  return(
    <>
      {cookieInfo}
    </>
  )

}
export default CookieComponent;